import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, MessageBoxVariant } from "@jti/ui/components/MessageBox";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import "./ProductQuantityError.scss";
export const ProductQuantityError = ({ isVisible = true, quantityLimit = "-", className, ...restProps }) => {
    const { __ } = useTranslations();
    return (_jsx("div", { className: `product-quantity-error ${className ?? ""}`, ...restProps, children: _jsx(MessageBox, { isVisible: isVisible, variant: MessageBoxVariant.warning, children: _jsxs(_Fragment, { children: [__("libs.ui.notification.limit.sku"), " (", quantityLimit, ")"] }) }) }));
};
//# sourceMappingURL=ProductQuantityError.js.map